import { GuardedComponent } from '../components/guarded-component';
import AuditLogPage from '../features/masters/audit-log/audit-log.page';
import ResetPassword from '../features/password/reset-password';
import { UserPermissionName } from '../models/user-permission-name';

export const ResetPasswordRoute = {
  path: '/reset-password',
  name: 'Reset Password',
  children: [
    {
      index: true,
      element: (
        // <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_AUDITLOG]} showPermissionError>
          <ResetPassword />
        // </GuardedComponent>
      ),
    },
  ],
};